import Entity from '../../../../../../foundation/domain/Entity';
import EntityId from '../../../../../../foundation/domain/EntityId';
import Preferences from './Preferences';
import Organization from '../../../../organizations/domain/aggregates/organization/Organization';
import Name from './Name';

export default class User extends Entity<User> {

	public constructor (id: EntityId<User>, private emailAddress: string | null, private username: string | null, private organizationId: EntityId<Organization>, private name: Name | null, private preferences: Preferences) {
		super(id);
	}

	public getEmailAddress () {
		return this.emailAddress;
	}

	public getDisplayName () {
		return this.username !== null ? this.username : this.name !== null ? this.name.getFirstName() + ' ' + this.name.getLastName() : 'Guest';
	}

	public getUsername () {
		return this.username;
	}

	public getOrganizationId ()  {
		return this.organizationId;
	}

	public isOrganizationAccount () {
		return !this.organizationId.isNull();
	}

	public getName () {
		return this.name;
	}

	public isSignedUp () {
		return this.emailAddress !== null;
	}

	public isErik () {
		return this.username === 'Erik';
	}

	public getPreferences () {
		return this.preferences;
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/users/domain/aggregates/user/User.ts